import { CurrentDataType } from "types/business/CurrentDataType";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = CurrentDataType;

export const useDefaultObservableCurrentDataType = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectCurrentDataType extends BehaviorSubject<CurrentType> {}
